import { Space, Typography } from "antd";
// import { UserAvatar } from "@rumble-it/common-components/src/components/UserAvatar";
import { Link } from "react-router-dom";
import { CarOutlined, UserOutlined } from "@ant-design/icons";
import { Dossier } from "@rumble-it/common-lib/types/models/Dossier.interface";
import { useCurrentUser } from "../../../../lib/hooks/useCurrentUser";
import { Card, LicensePlate } from "@rumbledirect/ui";

interface KanbanCardProps {
  dossier: Dossier;
}

const { Text } = Typography;

export const KanbanCard = ({ dossier }: KanbanCardProps) => {
  const currentUser = useCurrentUser();

  const hasAgentsPermission = currentUser?.permissions?.includes(
    "admin_rumble_agents_nav",
  );

  const href = hasAgentsPermission
    ? `/agents/dossiers/${dossier?.id}`
    : `/dossiers/${dossier?.id}`;

  return (
    <Link to={href}>
      <Card
        className="hover:shadow-md cursor-pointer"
        size="small"
        key={dossier?.id}
      >
        <Space direction="vertical" size={8} style={{ width: "100%" }}>
          <Space align="start" className="w-full justify-between">
            <LicensePlate country="NL">
              {dossier?.vehicle?.licensePlate?.identifier}
            </LicensePlate>
            {/* TODO: Await task module */}
            {/* {dossier?.assignee && <UserAvatar fullName={dossier?.assignee} />} */}
          </Space>
          <Space>
            <CarOutlined />
            <Text>
              {dossier?.vehicle?.brand} {dossier?.vehicle?.model}
            </Text>
          </Space>
          <Space>
            <UserOutlined />
            <Text>{dossier?.driver?.person?.fullName}</Text>
          </Space>
        </Space>
      </Card>
    </Link>
  );
};
